const schemaReduced = {
  id: "",
  line: "",
  personalSerial: "",
  serial: ""
};

export default schemaReduced;
